<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" [resizable]="false"
  appendTo="body">

  <p-header>
    <span>License Deactivation Wizard</span>
  </p-header>

  <div class="wizard-container">
    @if (page === WelcomePage) {
      <div>
        <p style="margin-top: 30px;">
          This wizard will step you through the process of deactivating your UVexplorer Server license.
        </p>
        <p style="margin-top: 20px;">
          To continue, click Next.
        </p>
      </div>
    }
    @if (page === CompletionPage) {
      <div>
        <p style="margin-top: 30px;">
          Congratulations!  You have successfully deactivated your license.
        </p>
        <p style="margin-top: 20px;">
          To close this wizard, click Finish.
        </p>
      </div>
    }
    @if (page === OnlinePage) {
      <div>
        <p style="margin-top: 30px;">
          Click the Deactivate button below to deactivate your license.
        </p>
      </div>
    }
    @if (page === OnlineFailedPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          {{onlineFailedLabel}}
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          If you would like to try again, click the Back button.
        </p>
      </div>
    }
    @if (page === OfflineQueryPage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px;">
          It appears that this computer is currently not connected to the Internet.
          Therefore, online deactivation is not possible at this time.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          You can try again later when this computer is connected to the Internet.
          If you can connect this computer to the Internet, we recommend that you do so
          and retry online deactivation.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          If you are unable to connect this computer to the Internet, you can opt to do
          offline deactivation instead.  Offline deactivation is a little more work on your part,
          but it's not hard.  To do offline deactivation, you will need access to a computer
          that is connected to the Internet so you can access our web site.
        </p>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          To retry online deactivation, click the Back button.<br />
          To do offline deactivation, click the Deactivate button.
        </p>
      </div>
    }
    @if (page === OfflinePage) {
      <div>
        <p style="margin-left: 50px; margin-right: 50px; margin-top: 30px; font-weight: bold;">
          The software has now been deactivated on this computer.  However, the UVnetworks licensing server
          is not aware of this deactivation.  Complete the following steps in order to notify our licensing
          server about the deactivation, thus allowing you to reuse the license on another computer.
        </p>
        <ol style="margin-left: 50px; margin-right: 50px; margin-top: 20px;">
          <li><a style="text-decoration: underline;" (click)="onSaveDeactivationRequest()">Click here</a>
          to download a Deactivation Request file./>
        </li>
        <li>Take the Deactivation Request file to a computer that has Internet access (e.g., using a flash drive).</li>
        <li>In a web browser, go to <a style="text-decoration: underline;" href="https://www.uvexplorer.com/offline-deactivation" target="_blank">https://www.uvexplorer.com/offline-deactivation</a>
      and upload the Deactivation Request file using the web form.</li>
      <li>Click the Next button below.</li>
    </ol>
  </div>
}
</div>

<p-footer>
  <button type="button" pButton [disabled]="!enableBack" (click)="onBackClicked()" label="{{backLabel}}"></button>
  <button type="button" pButton [disabled]="!enableNext" (click)="onNextClicked()" label="{{nextLabel}}"></button>
  <button type="button" pButton [disabled]="!enableCancel" (click)="onCancelClicked()" label="{{cancelLabel}}"></button>
</p-footer>

</p-dialog>
